<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : outStockBills.pkid > 0 ? '编辑' : '新建'"
      width="1500px"
      class="adaptationModal"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="outStockBills"
        :rules="ruleValidate"
        label-width="80px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="outStockBills.pkid" :span="12">
          <el-form-item label="出库单号" prop="billNo">
            <el-input v-model="outStockBills.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出库类型" prop="outStockType">
            <el-select v-model="outStockBills.outStockType" :disabled="outStockBills.pkid > 0">
              <el-option label="生产领料" :value="2"/>
              <el-option label="委外发料" :value="4"/>
              <el-option label="超领出库" :value="11"/>
              <el-option label="客供退料" :value="13"/>
              <el-option label="供应商退货_送货单(当月)" :value="14"/>
              <el-option label="供应商退货_退货单(跨月)" :value="15"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
            v-if="outStockBills.outStockType=== 2 ||outStockBills.outStockType=== 11"
            :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="outStockBills.relBillNo" placeholder="请输入关联单号" readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="selectProductionOrder"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-else-if="outStockBills.outStockType === 14" :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="outStockBills.relBillNo" placeholder="请输入关联单号" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.supplierSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-else-if="outStockBills.outStockType === 13" :span="12">
          <el-form-item label="客户名称" prop="customerNo">
            <el-input v-model="outStockBills.customerName" readonly placeholder="请选择客户" clearable>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectCustomer.open()">选择</el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col v-else-if="outStockBills.outStockType === 15 || outStockBills.outStockType === 4" :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="outStockBills.relBillNo" placeholder="请输入关联单号" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.purchaseOrderSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="note">
            <el-input v-model="outStockBills.note" type="textarea" placeholder="请输入" autosize/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-col v-if="isPosting" :span="12">
            <el-form-item label="过账时间">
              <el-date-picker
                  v-model="outStockBills.postTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
      <el-button
          v-if="outStockBills.outStockType === 11 || outStockBills.outStockType=== 2"
          type="primary"
          :disabled="isPosting || (isShowRelOrder && !outStockBills.relBillNo)"
          @click="selectMaterialByFilter">
        添加物料
      </el-button>
      <el-button
          v-else-if="outStockBills.outStockType === 14"
          type="primary"
          :disabled="isPosting || (isShowRelOrder && !outStockBills.relBillNo)"
          @click="selectReconcileSelect">
        添加物料
      </el-button>
      <el-button
          v-else
          type="primary"
          :disabled="isPosting || outStockBills.outStockType === 15 || outStockBills.outStockType === 4 || (isShowRelOrder && !outStockBills.relBillNo)"
          @click="$refs.selectMaterial.open()">
        添加物料
      </el-button>
      <div class="editTitle">出库明细</div>
      <Table
          border
          stripe
          :columns="columns"
          :data="outStockBills.outStockBillDetailVOS">
        <template slot="action" slot-scope="{ index }">
          <el-button type="danger" @click="outStockBills.outStockBillDetailVOS.splice(index, 1)">删除</el-button>
        </template>
        <template slot="locationNo" slot-scope="{ row, index }">
          <el-select v-model="row.locationNo" placeholder="请选择" @change="quantityHandle(row, index)">
            <el-option
                v-for="item in constants.locationNo.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </template>
        <template slot="quantity" slot-scope="{ row, index }">
          <el-input-number
              v-model="row.quantity"
              :disabled="isPosting"
              style="width: 100%"
              :min="0"
              @change="quantityHandle(row, index)"/>
        </template>
        <template slot="actualQuantity" slot-scope="{ row, index }">
          <span v-if="outStockBills.outStockType !== 4">
            <el-input-number
                v-if="row.instockQty>0"
                v-model="row.actualQuantity"
                :disabled="!isPosting"
                style="width: 100%"
                :min="0"
                :max="row.quantity-row.instockQty"
                @change="quantityHandle(row, index)"/>
            <el-input-number
                v-else
                v-model="row.actualQuantity"
                :disabled="!isPosting"
                style="width: 100%"
                :min="0"
                :max="row.quantity"
                @change="quantityHandle(row, index)"/>
          </span>
          <span v-else>
            <el-input-number
                v-model="row.actualQuantity"
                :disabled="!isPosting"
                style="width: 100%"
                :min="0"
                @change="quantityHandle(row, index)"/>
          </span>
        </template>
        <template slot="returnType" slot-scope="{ row, index }">
          <el-select v-model="row.returnType" placeholder="请选择" @change="quantityHandle(row, index)">
            <el-option
                v-for="item in constants.returnType.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button
          v-if="!isPosting"
          :disabled="disabled"
          :loading="submitLoading"
          type="primary"
          @click="submitHandle">确定</el-button>
      <el-button v-if="isPosting" :loading="submitLoading" type="primary" @click="postToSap">过账</el-button>
    </span>
    <production-order-select ref="productionOrderSelect" @select="productionOrderSelect"/>
    <material-select ref="selectMaterial" :is-multi-select="true" @select-change="materialSelect"/>
    <material-select-by-filter ref="selectMaterialByFilter" @select="materialSelectByFilter"/>
    <reconcile-order-select ref="reconcileSelect" @select="reconcileSelect"/>
    <supplier-select ref="supplierSelect" @select="supplierSelect"/>
    <purchase-order-select ref="purchaseOrderSelect" @select="purchaseOrderSelect"/>
  </el-dialog>
</template>

<script>
  import ProductionOrderSelect from "@/views/ProductionManagement/ProductionOrder/ProductionOrderSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import constants from "@/util/constants";
  import MaterialSelectByFilter from "@/views/information/Material/MaterialSelectByFilter";
  import ReconcileOrderSelect from "@/views/PurchaseOrderManager/ReconcileOrder/ReconcileOrderSelect";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";
  import PurchaseOrderSelect from "@/views/PurchaseOrderManager/PurchaseOrder/PurchaseOrderSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";

  export default {
    name: "OutStockOrderDetail",
    components: {
      CustomerSelect,
      PurchaseOrderSelect,
      SupplierSelect,
      ReconcileOrderSelect,
      MaterialSelectByFilter,
      MaterialSelect,
      ProductionOrderSelect,
    },
    data() {
      return {
        constants,
        isPosting: false,
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        outStockBills: {
          pkid: 0,
          billNo: "",
          outStockType: "",
          queryType: "",
          relBillNo: "",
          relBillId: "",
          customerNo: "",
          customerName: "",
          postTime: "",
          note: "",
          requireDate: "",
          outStockBillDetailVOS: [],
        },
        columns: [],
        ruleValidate: {
          outStockType: {required: true, message: "出库类型不能为空", trigger: "blur"},
          relBillNo: {required: true, message: "关联单号不能为空", trigger: "blur"},
        },
        productionColumns: [
          {
            title: "生产订单号",
            key: "productionOrderNo",
            width: 120,
            align: "center",
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            title: "老料号",
            key: "mappingMaterialNo",
            width: 120,
            align: "center",
            tooltip: true,
          },
          {
            title: "物料名称",
            key: "materialName",
            width: 180,
            tooltip: true,
          },
          {
            title: "规格型号",
            key: "specification",
            width: 180,
            tooltip: true,
          },
          {
            title: "所属仓位",
            width: 140,
            align: "center",
            slot: "locationNo",
          },
          {
            title: "小仓位",
            width: 140,
            align: "center",
            key: "warehouseNo",
            tooltip: true,
          },
          {
            title: "库存数量",
            width: 140,
            align: "center",
            key: "locationNumber",
            tooltip: true,
          },
          {
            title: "单据数量",
            width: 180,
            align: "center",
            slot: "quantity",
          },
          {
            title: "本次出库数量",
            width: 180,
            align: "center",
            slot: "actualQuantity",
          },
          {
            title: "已过账数量",
            width: 140,
            align: "center",
            key: "instockQty",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
        returnColumns: [
          {
            title: "订单号",
            key: "refBillNo",
            width: 130,
            align: "center",
          },
          {
            title: "订单行号",
            key: "relRowIndex",
            width: 100,
            align: "center",
          },
          {
            title: "采购订单号",
            key: "purchaseOrder",
            width: 120,
            align: "center",
          },
          {
            title: "采购订单行项",
            key: "purchaseOrderIndex",
            width: 110,
            align: "center",
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            title: "物料名称",
            key: "materialName",
            width: 180,
            tooltip: true,
          },
          {
            title: "规格型号",
            key: "specification",
            tooltip: true,
          },
          {
            title: "所属仓位",
            width: 140,
            align: "center",
            slot: "locationNo",
          },
          {
            title: "库位编号",
            width: 140,
            align: "center",
            slot: "warehouseNo",
          },
          {
            title: "单据数量",
            width: 180,
            align: "center",
            slot: "quantity",
          },
          {
            title: "本次出库数量",
            width: 180,
            align: "center",
            slot: "actualQuantity",
          },
          {
            title: "已过账数量",
            width: 140,
            align: "center",
            key: "instockQty",
          },
          {
            title: "退料类型",
            width: 140,
            align: "center",
            slot: "returnType",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
        purchaseDetailColumns: [
          {
            title: "订单号",
            key: "refBillNo",
            width: 130,
            align: "center",
          },
          {
            title: "订单行号",
            key: "relRowIndex",
            width: 100,
            align: "center",
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            title: "物料名称",
            key: "materialName",
            width: 180,
            tooltip: true,
          },
          {
            title: "规格型号",
            key: "specification",
            tooltip: true,
          },
          {
            title: "所属仓位",
            width: 140,
            align: "center",
            slot: "locationNo",
          },
          {
            title: "库位编号",
            width: 140,
            align: "center",
            slot: "warehouseNo",
          },
          {
            title: "单据数量",
            width: 180,
            align: "center",
            slot: "quantity",
          },
          {
            title: "本次出库数量",
            width: 180,
            align: "center",
            slot: "actualQuantity",
          },
          {
            title: "已过账数量",
            width: 140,
            align: "center",
            key: "instockQty",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    computed: {
      // 是否显示关联单号
      isShowRelOrder() {
        // 确保outStockType是数字类型
        const outStockType = Number(this.outStockBills.outStockType);
        console.log("outStockType", outStockType && outStockType !== 13);
        return !!outStockType && outStockType !== 13;
      },
    },
    methods: {
      open(row, mark, isPosting) {
        this.dialogVisible = true;
        if (isPosting) {
          this.isPosting = isPosting;
        }
        if (mark) {
          this.disabled = mark;
        }
        if (row) {
          this.getData(row.pkid);
        }
      },
      getColumns() {
        if (this.outStockBills.outStockType === 15) {//供应商退货_退货单(跨月)
          this.columns = this.purchaseDetailColumns;
        } else if (this.outStockBills.outStockType === 14) {
          this.columns = this.returnColumns;
        } else {
          this.columns = this.productionColumns;
        }
      },
      selectProductionOrder() {
        if (this.outStockBills.outStockType === 11 || this.outStockBills.outStockType=== 2  || this.outStockBills.outStockType === 13)
          this.$refs.productionOrderSelect.open(false);
      },
      materialSelect(row) {
        if (row.length === 0) {
          return;
        }
        row.forEach(item => {
          let obj = {
            materialId: item.id,
            materialNo: item.no,
            materialName: item.name,
            quantity: 1,
            unit: item.unit,
            warehouseNo: item.locationNo,
          };
          if (this.outStockBills.outStockType===13) {//客供退料
            obj.customerNo = this.outStockBills.customerNo;
          }
          this.outStockBills.outStockBillDetailVOS.push(obj);
        });
        this.getColumns();
      },
      selectReconcileSelect() {
        this.$refs.reconcileSelect.open(this.outStockBills.relBillNo);
      },
      purchaseOrderSelect(row) {
        this.outStockBills.relBillNo = row.buyOrderNo;
        if (row.pkId > 0) {
          this.$http
            .get("basic", `sapPurchaseOrders/${row.pkId}`)
            .then((resp) => {
              if (resp.success) {
                this.$message.success("获取采购明细成功！");
                console.log(resp.data);
                if (resp.data.details.length > 0) {
                  let newList = resp.data.details.filter(item => item.qty !== item.hasInStorageQty);
                  console.log(newList);
                  newList.forEach(item => {
                    let obj = {
                      refBillId: item.mastPKID,
                      refBillNo: item.evaluate,
                      refBillDetailId: item.pkId,
                      relRowIndex: item.rowNum,
                      materialNo: item.partNo,
                      materialName: item.partNameSpec,
                      actualQuantity: item.qty,
                      quantity: item.qty,
                      locationNo: item.positionNo,
                      unit: item.unit,
                      purchaseOrder: row.buyOrderNo,
                      purchaseOrderIndex: item.rowNum,
                      supplierNo: row.gysCode,
                      productionOrderNo: item.evaluate,
                    };
                    this.outStockBills.outStockBillDetailVOS.push(obj);
                  });
                }
              }
            }).catch((e) => {
              console.log(e);
              this.$message.error("获取采购明细失败！");
            });
        }
        this.getColumns();
      },
      supplierSelect(row) {
        this.outStockBills.relBillNo = row.no;
      },
      reconcileSelect(row) {
        row.forEach(item => {
          let obj = {
            refBillId: item.asnId,
            refBillDetailId :item.asnMaterialId,
            refBillNo: item.asnNo,
            relRowIndex: item.asnRowIndex,
            purchaseOrder:item.evaluate,
            purchaseOrderIndex:item.poDetailRowNo,
            materialNo: item.partNo,
            materialName: item.partNameSpec,
            actualQuantity: item.instockQuantity,
            locationNo: item.locationNo,
            returnType: "",
            unit: item.unit,
            warehouseNo :item.warehouseNo,
          };
          this.outStockBills.outStockBillDetailVOS.push(obj);
          console.log(this.outStockBills.outStockBillDetailVOS);
        });
        this.getColumns();
      },

      selectMaterialByFilter() {
        if (this.outStockBills.outStockType === 2) {
          this.outStockBills.queryType = "生产领料";
        } else if (this.outStockBills.outStockType === 4) {
          this.outStockBills.queryType = "委外发料";
        } else if (this.outStockBills.outStockType === 11) {
          this.outStockBills.queryType = "超领出库";
        } else if (this.outStockBills.outStockType === 12) {
          this.outStockBills.queryType = "生产退库";
        }
        this.$refs.selectMaterialByFilter.open(this.outStockBills);
      },
      materialSelectByFilter(row) {
        if (row.length > 0) {
          row.forEach(item => {
            let obj = {
              materialNo: item.materialCode,
              materialName: item.materialDescription,
              quantity: item.requirementNum,
              actualQuantity: item.requirementNum,
              locationNo: item.positionNo,
              refBillId: item.mastPKID,
              refBillDetailId: item.pkId,
              relRowIndex: item.ic,
              productionOrderNo: item.it,
              unit: item.unit,
              warehouseNo:item.locationNo,
            };

            this.outStockBills.outStockBillDetailVOS.push(obj);
          });
        }
        this.getColumns();
      },
      // 获取出库单详情
      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `outStockBills/${pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.outStockBills = Object.assign(this.outStockBills, resp.data);
              this.getColumns();
              this.outStockBills.outStockBillDetailVOS.forEach((item) => {
                if (item.instockQty !== 0) {
                  item.actualQuantity = item.quantity - item.instockQty;
                }
              });
              if (this.isPosting) {
                this.outStockBills.postTime = this.getFormatDate(new Date());
              }
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " 00:00:00";
      },
      quantityHandle(row, index) {
        this.$set(this.outStockBills.outStockBillDetailVOS, index, row);
      },

      postToSap() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.outStockBills.outStockBillDetailVOS.length) {
              return this.$confirm("入库明细不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
            }
            const arr = this.outStockBills.outStockBillDetailVOS.filter((item) => !item.locationNo);
            if (arr.length) {
              return this.$confirm("请选择所属仓库", "错误", {
                type: "error",
                showCancelButton: false,
              });
            }
            if (this.outStockBills.outStockType!==4) {
              if (this.outStockBills.outStockBillDetailVOS.some(item => item.instockQty + item.actualQuantity > item.quantity)) {
                this.$confirm("本次出库数量不能大于剩余数量！", "错误", {
                  type: "error",
                  showCancelButton: false,
                });
                return;
              }
            }
            this.submitLoading = true;
            this.$http
              .post("basic", "outStockBills/postToSap", this.outStockBills)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("操作失败");
              });
          }
        });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.outStockBills.outStockBillDetailVOS.length) {
              this.$confirm("出库明细不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            if (this.outStockBills.outStockType === 12) {
              if (this.outStockBills.outStockBillDetailVOS.some(item => item.actualQuantity - (this.outStockBills.pkid > 0 ? item.quantity : 0) > item.originQuantity - item.returnedQuantity)) {
                this.$confirm("退库数量不能大于可退数量！", "错误", {
                  type: "error",
                  showCancelButton: false,
                });
                return;
              }
            }
            // this.outStockBills.outStockBillDetailVOS.forEach(item => item.quantity = item.actualQuantity);
            this.submitLoading = true;
            this.$http
              .save("basic", "outStockBills", this.outStockBills)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.outStockBills.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      selectCustomer(row) {
        console.log(row);
        this.outStockBills.customerName = row.customerName;
        this.outStockBills.customerNo = row.outerNo;
        this.outStockBills.relBillNo = row.outerNo;
        this.outStockBills.relBillId = row.customerID;
        this.outStockBills.customerId = row.customerID;
      },
      productionOrderSelect(row) {
        this.outStockBills.outStockBillDetailVOS = [];
        if (this.outStockBills.outStockType === 11 || this.outStockBills.outStockType === 2 || this.outStockBills.outStockType === 13) {
          this.outStockBills.relBillNo = row.map(item => item.orders).join(",");
        } else if (this.outStockBills.outStockType === 12) {
          //生产退库
          let param = {
            taskDispatchBillId: row.pkid,
          };
          this.$http
            .get("basic", "inStockBills/stocked", param)
            .then((resp) => {
              if (resp.success) {
                this.outStockBills.relBillId = row.pkid;
                this.outStockBills.relBillNo = row.billNo;
                this.outStockBills.productionOrderNo = row.billNo;
                this.outStockBills.workCenterId = row.workCenterId;
                resp.data.forEach(item => {
                  item.originQuantity = item.quantity;
                  item.actualQuantity = item.quantity - item.returnedQuantity;
                  item.inStockNo = item.billNo;
                  this.outStockBills.outStockBillDetailVOS.push(item);
                });
              }
            });
        }
        this.getColumns();
      },
    },
  };
</script>
